import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({
    name: 'basicMarkdown',
    standalone: true,
})
export class BasicMarkdownPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(value: string): SafeHtml {
        if (!value) return '';

        // Normalize newlines and split into lines
        const lines = value.replace(/\r\n/g, '\n').split('\n');
        const htmlLines: string[] = [];
        let inList = false;

        for (const line of lines) {
            const trimmed = line.trim();

            if (/^[-*]\s+/.test(trimmed)) {
                // Start or continue unordered list
                if (!inList) {
                    htmlLines.push('<ul>');
                    inList = true;
                }
                const content = trimmed.replace(/^[-*]\s+/, '');
                htmlLines.push(`<li>${this.processStrong(content)}</li>`);
            } else {
                // End list if needed
                if (inList) {
                    htmlLines.push('</ul>');
                    inList = false;
                }

                if (trimmed.length > 0) {
                    htmlLines.push(`<p>${this.processStrong(trimmed)}</p>`);
                }
            }
        }

        // Close list if still open
        if (inList) {
            htmlLines.push('</ul>');
        }

        const resultHtml = htmlLines.join('\n');
        return this.sanitizer.bypassSecurityTrustHtml(resultHtml);
    }

    private processStrong(text: string): string {
        return text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    }
}
